import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import CaseService from "../../../../services/CaseService";
import BundleService from "../../../../services/BundleService"; // NEW
import COLORS from "../../../../assets/Colors";
import moment from "moment";
import { useSnackbar } from "notistack";
import useLoader from "../../../../hooks/useLoader";
import ViewKeywords from "../../../internal/DrawerTable/ViewExtract";
import HttpsLockOpen from "@material-ui/icons/LockOpen";
import HttpsIcon from "@material-ui/icons/Https";
import PublicIcon from "@material-ui/icons/Public";
import { Tooltip } from "@material-ui/core";
import DocumentViewer from "./DocViewer";
import { Spinner } from "./TrailBundle";
import { CoreBundle, Layers } from "./components/Icons";
import * as PDFJS from "pdfjs-dist/legacy/build/pdf";
import workerSrc from "pdfjs-dist/legacy/build/pdf.worker.entry";
import {
  EmptyState,
  EmptyText,
  ClearSearchBtn,
  SBadge,
  SBadgeDot,
  SBadgeWrap,
  SPageRef,
  SearchHighlight,
  DataRow,

  SectionBar,
  SfHeaderLeft,

  SfName,
  Shell,
  SideVisibilityDot,
  Sidebar,
  SidebarHeader,
  SidebarTitle,
  SidebarToggleBtn,
  CollapsedSidebarBar,
  SidebarCollapseIcon,
  SidebarExpandIcon,

  SidebarSummary,
  SidebarSummaryItem,
  SourceDot,
  DateLine,
  DateText,

  DimText,
  DocDescMeta,
  DocDescRow,
  DocDescText,
  DocIconFrame,
  DocName,
  DocNameRow,
  DocRef,
  Checkbox,
  ChevronWrap,
  NavAddBtn,
  NavBadge,
  NavIconWrap,
  NavLabel,
  NavRow,
  NavSection,
  NoResultsBanner,
  PageBtn,
  PageChip,
  PageControls,
  PageIconBox,
  PageSub,
  PageTitle,
  PageTitleGroup,
  PaginationBar,
  PaginationInfo,
  PaginationRight,
  PerPageSelect,
  Pill,
  PrimaryBtn,
  MobileCardList,
  MobileDocBody,
  VisibilityControl,
  SubNavEmpty,
  BundleNavRow,
  BundleNavChevron,
  BundleNavContent,
  BundleNavIdChip,
  ViewerPane,
  MobileDocCard,
  MobileDocIconBox,
  MobileDocName,
  MobileDocMeta,
  Content,
  OwnerBadge,
  EmptyHint,
  EmptyIconBox,
  FilterPills,
  FilterLabel,
  FilterStrip,
  SubNav,
  BundleNavName,
  SubFolderNavList,

  SubFolderNavRow,
  SubFolderChevron,
  SubFolderNavContent,
  SubFolderPrefixChip,
  SubFolderName,
  TabNavList,
  TabLabel,
  TabLabelGroup,
  TabNavCount,
  TabNavEmpty,
  TabNavLabel,
  TabNavRow,
  TabSepInner,
  TabSepMeta,
  TabSeparatorTd,
  TableWrap,
  TimeLine,
  TopBar,
  TopLeft,
  BundleBlock,
  BundleHeader,
  BundleSearchBar,
  BundlesWrap,
  BundleHeaderLeft,

  BundleHeaderTop,
  BundleTitle,
  MetaDivider,

  ViewportWrap,

  BundleStat,
  BundleStats,
  BundleHeaderActions,

  EmptyRowBlock,
  SubFolderBlock,
  SubFolderHeader,
  InnerTable,
  InnerTr,
  ColTh,
  EmptyRowTd,

  RefChip,

  MobileSfCard,
  MobileEmpty,
  MobileSfCards,
  MobileSfCardTop,
  MobileSfCardName,
  MobileSfCardMeta,
  Main,
  HamburgerBtn,
  BackBtn,
  Overlay,
  IcoChevronDown,
  IcoChevronLeft,
  IcoChevronRight,
  IcoFile,
  IcoFolder,

  IcoLayers,
  IcoLock,
  IcoClock,
  IcoMenu,

  IcoPlus,
  IcoSearch,

  IcoX,
  BundleIdChip,
  SfLabel,
  BundleMeta,
  VisibilityBadge,
} from "./styles";

PDFJS.GlobalWorkerOptions.workerSrc = workerSrc;

const G = {
  teal: COLORS.BTN_GREEN || "#00838C",
  tealLight: "#E6F4F5",
  tealMid: "#B2DDE0",
  tealDark: "#006870",
  tealGhost: "#F0FAFB",
  navy: COLORS.COLOR_DARK || "#293461",
  navyLight: "#3D4A82",
  slate800: "#1E293B",
  slate700: "#334155",
  slate600: "#475569",
  slate500: "#64748B",
  slate400: "#94A3B8",
  slate300: "#CBD5E1",
  slate200: COLORS.BORDER_GREY || "#E1E3EE",
  slate100: COLORS.TABLE_GREY_CELL || "#F4F6FF",
  slate50: "#F8FAFC",
  white: "#FFFFFF",
  red: COLORS.REMOVE_RED || "#FF3C3C",
  redDark: COLORS.LOGOUT_RED || "#D91B1B",
  redLight: "#FFF1F1",
  amber: "#F59E0B",
  amberLight: "#FFFBEB",
  emerald: "#10B981",
  emeraldLight: "#ECFDF5",
  indigo: "#4F46E5",
  indigoLight: "#EEF2FF",
  shadowSm: "0 1px 3px rgba(41,52,97,0.08), 0 1px 2px rgba(41,52,97,0.04)",
  shadowMd: "0 4px 12px rgba(41,52,97,0.10), 0 2px 4px rgba(41,52,97,0.06)",
  shadowLg: "0 10px 30px rgba(41,52,97,0.12), 0 4px 8px rgba(41,52,97,0.06)",
};

const SOURCE_CFG = {
  Claimant: {
    bg: "#FFFBEB",
    border: "#FDE68A",
    dot: "#F59E0B",
    text: "#92400E",
  },
  Respondent: {
    bg: "#EEF2FF",
    border: "#C7D2FE",
    dot: "#4F46E5",
    text: "#3730A3",
  },
  Neutral: {
    bg: "#ECFDF5",
    border: "#A7F3D0",
    dot: "#10B981",
    text: "#065F46",
  },
};

const VISIBILITY_OPTIONS = [
  { value: "me", mode: "private", label: "Share with my Team" },
  { value: "all", mode: "all", label: "Shared with all Parties" },
  { value: "others", mode: "neutral", label: "Shared with CM & Neutral" },
  { value: "strictMode", mode: "private", label: "Private (Only me)" },
];

const getVisibilityLabel = (value) =>
  VISIBILITY_OPTIONS.find((item) => item.value === value)?.label || "Private";
const getVisibilityMode = (value) =>
  VISIBILITY_OPTIONS.find((item) => item.value === value)?.mode || "private";

const normalizeVisibility = (value) => value || "me";
const isStrictVisibility = (value) =>
  normalizeVisibility(value) === "strictMode";
const isPrivateVisibility = (value) => isStrictVisibility(value);
const isPrivateBundle = (bundle) => isPrivateVisibility(bundle?.visibilityType);

const getExhibitId = (doc) =>
  doc?.exhibitId ||
  doc?.exhibit_id ||
  doc?.exhibitCode ||
  doc?.exhibit_code ||
  doc?.properties?.exhibitId ||
  doc?.properties?.exhibit_id ||
  doc?.properties?.exhibitNo ||
  doc?.properties?.exhibit_no ||
  "—";
export const isPrivateAssignment = (assignment, subFolder, bundle) =>
  isPrivateVisibility(
    assignment?.visibilityType ||
    assignment?.subFolder?.visibilityType ||
    subFolder?.visibilityType ||
    bundle?.visibilityType,
  );

export const sourceChip = (group) => {
  switch (group) {
    case "Claimant":
      return {
        bg: "#EFF6FF",
        fg: "#1E40AF",
        dot: "#3B82F6",
        border: "#93C5FD",
      };
    case "Respondent":
      return {
        bg: "#FEF2F2",
        fg: "#991B1B",
        dot: "#EF4444",
        border: "#FCA5A5",
      };
    default:
      return {
        bg: G.slate100,
        fg: G.slate600,
        dot: G.slate400,
        border: G.slate200,
      };
  }
};

const SourceBadge = ({ source, pageRef }) => {
  const c = SOURCE_CFG[source] || {
    bg: G.slate100,
    border: G.slate200,
    dot: G.slate400,
    text: G.slate600,
  };
  return (
    <SBadgeWrap>
      <SBadge
        style={{
          background: c.bg,
          border: `1px solid ${c.border}`,
          color: c.text,
        }}
      >
        <SBadgeDot style={{ background: c.dot }} />
        {source}
      </SBadge>
      {pageRef && <SPageRef>{pageRef}</SPageRef>}
    </SBadgeWrap>
  );
};

const VisibilitySelect = ({ value, onChange, disabled }) => (
  <VisibilityControl
    value={value || "me"}
    onClick={(e) => e.stopPropagation()}
    onChange={(e) =>
      onChange(e.target.value, {
        mode: getVisibilityMode(e.target.value),
      })
    }
    disabled={disabled}
    title="Change visibility"
  >
    {VISIBILITY_OPTIONS.map((item) => (
      <option
        key={item.value}
        value={item.value}
        style={{ color: COLORS.COLOR_DARK }}
      >
        {item.label}
      </option>
    ))}
  </VisibilityControl>
);

const Highlight = ({ text = "", query = "" }) => {
  if (!query.trim()) return <>{text}</>;
  const regex = new RegExp(
    `(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
    "gi",
  );
  const parts = text.split(regex);
  return (
    <>
      {parts.map((p, i) =>
        regex.test(p) ? (
          <SearchHighlight key={i}>{p}</SearchHighlight>
        ) : (
          <React.Fragment key={i}>{p}</React.Fragment>
        ),
      )}
    </>
  );
};

/*

const apiBundleToInternal = (apiBundle) => {
  if (!apiBundle) return null;

  const bundleTabs = apiBundle.bundleTabs || [];
  const bundleFolders = apiBundle.bundleFolders || [];

  // A tab "belongs" to a subfolder only when it explicitly carries a prefix
  // that matches a bundleFolder entry. Tabs without a prefix are flat/unassigned.
  const tabsWithPrefix = bundleTabs.filter(
    (t) => t?.prefix != null && t.prefix !== "",
  );
  const tabsWithoutPrefix = bundleTabs.filter(
    (t) => t?.prefix == null || t.prefix === "",
  );

  const hasBundleFolders = bundleFolders.length > 0;

  let subFolders = [];

  if (hasBundleFolders) {
    // Build one subfolder per bundleFolder entry, matched strictly by prefix
    subFolders = bundleFolders.map((folder) => {
      const matchingTab = tabsWithPrefix.find(
        (t) =>
          String(t.prefix) === String(folder.prefix) ||
          String(t.code) === String(folder.prefix),
      );
      return {
        code: folder.prefix,
        name: folder.subFolderName,
        visibilityType:
          folder.visibilityType ||
          matchingTab?.visibilityType ||
          matchingTab?.assignments?.[0]?.visibilityType ||
          apiBundle.visibilityType ||
          "me",
        assignments: matchingTab?.assignments || [],
      };
    });

    // Any tabsWithPrefix that don't have a bundleFolder entry get their own subfolder
    tabsWithPrefix.forEach((tab) => {
      const code = tab.prefix || tab.code;
      if (!code) return;
      const exists = subFolders.some((sf) => String(sf.code) === String(code));
      if (!exists) {
        subFolders.push({
          code,
          name: tab.name || `Folder ${code}`,
          visibilityType:
            tab.visibilityType ||
            tab.assignments?.[0]?.visibilityType ||
            apiBundle.visibilityType ||
            "me",
          assignments: tab.assignments || [],
        });
      }
    });

    // Tabs WITHOUT a prefix → treat as a flat "__unassigned__" virtual subfolder
    // so their documents still appear in the table, just without a subfolder label
    if (tabsWithoutPrefix.length > 0) {
      const unassignedAssignments = tabsWithoutPrefix.flatMap(
        (t) => t.assignments || [],
      );
      if (unassignedAssignments.length > 0) {
        subFolders.push({
          code: "__unassigned__",
          name: "Unassigned",
          isMainFolder: true, // reuse existing flag → hides the SubFolderHeader label
          visibilityType:
            tabsWithoutPrefix[0]?.visibilityType ||
            tabsWithoutPrefix[0]?.assignments?.[0]?.visibilityType ||
            apiBundle.visibilityType ||
            "me",
          assignments: unassignedAssignments,
        });
      }
    }
  } else {
    // No bundleFolders at all — all tabs are flat regardless of prefix
    subFolders = [
      {
        code: "__main__",
        name: apiBundle.name || "Main Bundle",
        isMainFolder: true,
        visibilityType:
          bundleTabs[0]?.visibilityType ||
          bundleTabs[0]?.assignments?.[0]?.visibilityType ||
          apiBundle.visibilityType ||
          "me",
        assignments: bundleTabs.flatMap((t) => t.assignments || []),
      },
    ];
  }

  return {
    id: apiBundle.id,
    bundleCode: apiBundle.bundleCode,
    name: apiBundle.name,
    bundleType: apiBundle.bundleType,
    ownerRole: apiBundle.ownerRole,
    ownerId: apiBundle.ownerId,
    hearing: apiBundle.hearing,
    caseId: apiBundle.caseId,
    visibilityType: apiBundle.visibilityType || "me",
    totalPages: apiBundle.totalPages,
    createdAt: apiBundle.created_at,
    updatedAt: apiBundle.updated_at,
    hasBundleFolders,
    bundles: subFolders,
  };
};

*/

/*

const apiBundleToInternal = (apiBundle) => {
  if (!apiBundle) return null;

  const bundleTabs = apiBundle.bundleTabs || [];
  const bundleFolders = apiBundle.bundleFolders || [];
  const hasBundleFolders = bundleFolders.length > 0;

  const tabsWithPrefix = bundleTabs.filter(
    (t) => t?.prefix != null && String(t.prefix).trim() !== "",
  );
  const tabsWithoutPrefix = bundleTabs.filter(
    (t) => t?.prefix == null || String(t.prefix).trim() === "",
  );

  let subFolders = [];

  if (hasBundleFolders) {
    subFolders = bundleFolders.map((folder) => {
      const matchingTab = tabsWithPrefix.find(
        (t) =>
          String(t.prefix) === String(folder.prefix) ||
          String(t.code) === String(folder.prefix),
      );
      return {
        code: folder.prefix,
        name: folder.subFolderName,
        isMainFolder: false,
        visibilityType:
          folder.visibilityType ||
          matchingTab?.visibilityType ||
          matchingTab?.assignments?.[0]?.visibilityType ||
          apiBundle.visibilityType ||
          "me",
        assignments: matchingTab?.assignments || [],
      };
    });

    tabsWithPrefix.forEach((tab) => {
      const code = tab.prefix || tab.code;
      if (!code) return;
      const exists = subFolders.some((sf) => String(sf.code) === String(code));
      if (!exists) {
        subFolders.push({
          code,
          name: tab.name || `Folder ${code}`,
          isMainFolder: false,
          visibilityType:
            tab.visibilityType ||
            tab.assignments?.[0]?.visibilityType ||
            apiBundle.visibilityType ||
            "me",
          assignments: tab.assignments || [],
        });
      }
    });

    if (tabsWithoutPrefix.length > 0) {
      const flatAssignments = tabsWithoutPrefix
        .flatMap((t) => t.assignments || [])
        .sort((a, b) => Number(a.tabNum) - Number(b.tabNum));

      if (flatAssignments.length > 0) {
        subFolders.unshift({
          code: "__flat__",
          name: apiBundle.name || "Documents",
          isMainFolder: true,
          visibilityType:
            tabsWithoutPrefix[0]?.visibilityType ||
            tabsWithoutPrefix[0]?.assignments?.[0]?.visibilityType ||
            apiBundle.visibilityType ||
            "me",
          assignments: flatAssignments,
        });
      }
    }
  } else {
    const allAssignments = bundleTabs
      .flatMap((t) => t.assignments || [])
      .sort((a, b) => Number(a.tabNum) - Number(b.tabNum));

    subFolders = [
      {
        code: "__main__",
        name: apiBundle.name || "Main Bundle",
        isMainFolder: true,
        visibilityType:
          bundleTabs[0]?.visibilityType ||
          bundleTabs[0]?.assignments?.[0]?.visibilityType ||
          apiBundle.visibilityType ||
          "me",
        assignments: allAssignments,
      },
    ];
  }

  return {
    id: apiBundle.id,
    bundleCode: apiBundle.bundleCode,
    name: apiBundle.name,
    bundleType: apiBundle.bundleType,
    ownerRole: apiBundle.ownerRole,
    ownerId: apiBundle.ownerId,
    hearing: apiBundle.hearing,
    caseId: apiBundle.caseId,
    visibilityType: apiBundle.visibilityType || "me",
    totalPages: apiBundle.totalPages,
    createdAt: apiBundle.created_at,
    updatedAt: apiBundle.updated_at,
    hasBundleFolders,
    bundles: subFolders,
  };
};

*/

const apiBundleToInternal = (apiBundle) => {
  if (!apiBundle) return null;

  const bundleTabs = apiBundle.bundleTabs || [];
  const bundleFolders = apiBundle.bundleFolders || [];
  const hasBundleFolders = bundleFolders.length > 0;

  const seenPrefixes = new Set();
  const uniqueBundleFolders = bundleFolders.filter((f) => {
    const key = String(f.prefix).trim();
    if (seenPrefixes.has(key)) return false;
    seenPrefixes.add(key);
    return true;
  });

  const tabsWithPrefix = bundleTabs.filter(
    (t) => t?.prefix != null && String(t.prefix).trim() !== "",
  );
  const tabsWithoutPrefix = bundleTabs.filter(
    (t) => t?.prefix == null || String(t.prefix).trim() === "",
  );

  let subFolders = [];

  if (hasBundleFolders) {
    subFolders = uniqueBundleFolders.map((folder) => {
      const matchingTab = tabsWithPrefix.find(
        (t) =>
          String(t.prefix) === String(folder.prefix) ||
          String(t.code) === String(folder.prefix),
      );
      return {
        code: folder.prefix,
        name: folder.subFolderName,
        isMainFolder: false,
        visibilityType:
          folder.visibilityType ||
          matchingTab?.visibilityType ||
          matchingTab?.assignments?.[0]?.visibilityType ||
          apiBundle.visibilityType ||
          "me",
        assignments: (matchingTab?.assignments || []).sort(
          (a, b) => Number(a.tabNum) - Number(b.tabNum),
        ),
      };
    });

    tabsWithPrefix.forEach((tab) => {
      const code = tab.prefix || tab.code;
      if (!code) return;
      const exists = subFolders.some((sf) => String(sf.code) === String(code));
      if (!exists) {
        subFolders.push({
          code,
          name: tab.name || `Folder ${code}`,
          isMainFolder: false,
          visibilityType:
            tab.visibilityType ||
            tab.assignments?.[0]?.visibilityType ||
            apiBundle.visibilityType ||
            "me",
          assignments: (tab.assignments || []).sort(
            (a, b) => Number(a.tabNum) - Number(b.tabNum),
          ),
        });
      }
    });

    if (tabsWithoutPrefix.length > 0) {
      const flatAssignments = tabsWithoutPrefix
        .flatMap((t) => t.assignments || [])
        .sort((a, b) => Number(a.tabNum) - Number(b.tabNum));

      if (flatAssignments.length > 0) {
        subFolders.push({
          code: "__flat__",
          name: "Without Sub-folder",
          isMainFolder: true,
          visibilityType:
            tabsWithoutPrefix[0]?.visibilityType ||
            tabsWithoutPrefix[0]?.assignments?.[0]?.visibilityType ||
            apiBundle.visibilityType ||
            "me",
          assignments: flatAssignments,
        });
      }
    }

    subFolders.sort((a, b) => {
      const aMin =
        a.assignments.length > 0
          ? Math.min(...a.assignments.map((x) => Number(x.tabNum)))
          : Infinity;
      const bMin =
        b.assignments.length > 0
          ? Math.min(...b.assignments.map((x) => Number(x.tabNum)))
          : Infinity;
      return aMin - bMin;
    });
  } else {
    const allAssignments = bundleTabs
      .flatMap((t) => t.assignments || [])
      .sort((a, b) => Number(a.tabNum) - Number(b.tabNum));

    subFolders = [
      {
        code: "__main__",
        name: apiBundle.name || "Main Bundle",
        isMainFolder: true,
        visibilityType:
          bundleTabs[0]?.visibilityType ||
          bundleTabs[0]?.assignments?.[0]?.visibilityType ||
          apiBundle.visibilityType ||
          "me",
        assignments: allAssignments,
      },
    ];
  }

  return {
    id: apiBundle.id,
    bundleCode: apiBundle.bundleCode,
    name: apiBundle.name,
    bundleType: apiBundle.bundleType,
    ownerRole: apiBundle.ownerRole,
    ownerId: apiBundle.ownerId,
    hearing: apiBundle.hearing,
    caseId: apiBundle.caseId,
    visibilityType: apiBundle.visibilityType || "me",
    totalPages: apiBundle.totalPages,
    createdAt: apiBundle.created_at,
    updatedAt: apiBundle.updated_at,
    hasBundleFolders,
    bundles: subFolders,
  };
};

const apiListToInternal = (list) =>
  (Array.isArray(list) ? list : []).map(apiBundleToInternal).filter(Boolean);

const CoreBundleView = ({
  onBack,
  onNavigate,
  initialSource = "All",
  initialSection = "core",
  id,
  caseDetails,
  viewOnly = false,
  isActionsDisabled,
  setTrigger,
  agentRole,
}) => {
  const [activeSection, setActiveSection] = useState(initialSection);
  const [activeSource, setActiveSource] = useState(initialSource);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const [viewKeywords, setViewKeywords] = useState({ state: false });
  const [openTabs, setOpenTabs] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [selectedRows, setSelectedRows] = useState({});
  const { activeDoc, setActiveDoc } = useLoader();
  const [viewerPhase, setViewerPhase] = useState("idle");
  const exitTimerRef = useRef(null);
  const ANIM_DURATION = 320;
  const [coreExpanded, setCoreExpanded] = useState(initialSection === "core");
  const [trialExpanded, setTrialExpanded] = useState(
    initialSection === "trial",
  );
  const [privateExpanded, setPrivateExpanded] = useState(
    initialSection === "private",
  );
  const [recentlyViewedExpanded, setRecentlyViewedExpanded] = useState(true);
  const storageKey = `recentlyViewedDocs_${id || "default"}`;
  const [recentlyViewed, setRecentlyViewed] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  const isSameDocument = useCallback((doc1, doc2) => {
    if (!doc1 || !doc2) return false;
    if (doc1.s3url && doc2.s3url && doc1.s3url === doc2.s3url) return true;
    if (doc1.id && doc2.id && doc1.id === doc2.id) {
      if (!doc1.bundle && !doc2.bundle) return true;
      if (doc1.name === doc2.name) return true;
    }
    return doc1.name === doc2.name && doc1.s3url === doc2.s3url;
  }, []);

  const addRecentlyViewed = useCallback(
    (doc) => {
      if (!doc || !doc.name) return;
      setRecentlyViewed((prev) => {
        const filtered = prev.filter((item) => !isSameDocument(item, doc));
        const updated = [doc, ...filtered].slice(0, 20);
        try {
          localStorage.setItem(storageKey, JSON.stringify(updated));
        } catch (e) {
          console.error("Failed to save recently viewed documents", e);
        }
        return updated;
      });
    },
    [isSameDocument, storageKey],
  );

  const [bundleTreeExpanded, setBundleTreeExpanded] = useState({});
  const [subFolderExpanded, setSubFolderExpanded] = useState({});

  const [activeBundleId, setActiveBundleId] = useState(null);
  const [activeSubFolder, setActiveSubFolder] = useState(null);
  const [activeTabNum, setActiveTabNum] = useState(null);
  const [bundleSearch, setBundleSearch] = useState("");
  const [trialBundles, setTrialBundles] = useState([]);
  const [trialBundlesLoading, setTrialBundlesLoading] = useState(false);
  const [trialBundlesError, setTrialBundlesError] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();

  const fetchAllBundles = useCallback(async () => {
    setTrialBundlesLoading(true);
    setTrialBundlesError(null);
    try {
      const res = await BundleService.getBundleDocuments(`?caseId=${id}`);
      const list = res?.data ?? res;
      setTrialBundles(apiListToInternal(list));
    } catch (err) {
      setTrialBundlesError("Failed to load trial bundles");
      enqueueSnackbar("Failed to load trial bundles", { variant: "error" });
    } finally {
      setTrialBundlesLoading(false);
    }
  }, [id, enqueueSnackbar]);

  const fetchBundleByCode = useCallback(
    async (bundleCode) => {
      if (!bundleCode) return null;
      try {
        const res = await BundleService.getBundleDocuments(
          `?bundleCode=${bundleCode}&caseId=${id}`,
        );
        const raw = res?.data ?? res;
        const single = Array.isArray(raw) ? raw[0] : raw;
        const internal = apiBundleToInternal(single);
        if (!internal) return null;
        setTrialBundles((prev) => {
          const exists = prev.some((b) => b.id === internal.id);
          return exists
            ? prev.map((b) => (b.id === internal.id ? internal : b))
            : [...prev, internal];
        });
        return internal;
      } catch (err) {
        enqueueSnackbar("Failed to load bundle", { variant: "error" });
        return null;
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [enqueueSnackbar],
  );
  useEffect(() => {
    if (id) fetchAllBundles();
  }, [id, fetchAllBundles]);


  const openViewer = (doc) => {
    clearTimeout(exitTimerRef.current);
    if (!openTabs.find((t) => t.id === doc.id)) setOpenTabs((p) => [...p, doc]);
    setActiveDoc(doc);
    setViewerPhase("entering");
    requestAnimationFrame(() =>
      requestAnimationFrame(() => setViewerPhase("visible")),
    );
    addRecentlyViewed(doc);
  };
  const closeViewer = () => {
    setViewerPhase("exiting");
    exitTimerRef.current = setTimeout(() => {
      setActiveDoc(null);
      setViewerPhase("idle");
    }, ANIM_DURATION);
  };
  useEffect(() => () => clearTimeout(exitTimerRef.current), []);



  const handleBundleVisibilityChange = async (
    bundleId,
    visibilityType,
    meta = {},
  ) => {
    const prevBundles = trialBundles;
    setTrialBundles((p) =>
      p.map((b) =>
        b.id === bundleId
          ? {
            ...b,
            visibilityType: visibilityType,
            mode: meta.mode || getVisibilityMode(visibilityType),
          }
          : b,
      ),
    );
    try {
      setLoader({ state: true, message: "Updating visibility..." });
      await BundleService.update_bundle(bundleId, {
        visibilityType,
        mode: meta.mode || getVisibilityMode(visibilityType),
      });
      enqueueSnackbar("Bundle visibility updated", { variant: "success" });
      fetchAllBundles();
    } catch (err) {
      setTrialBundles(prevBundles);
      enqueueSnackbar(err?.message || "Failed to update visibility", {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  };

  /*

  const handleSubFolderVisibilityChange = async (
    bundleId,
    sfCode,
    visibilityType,
  ) => {
    const prevBundles = trialBundles;
    setTrialBundles((p) =>
      p.map((b) =>
        b.id !== bundleId
          ? b
          : {
              ...b,
              bundles: (b.bundles || []).map((sf) =>
                sf.code !== sfCode
                  ? sf
                  : {
                      ...sf,
                      visibilityType,
                      assignments: (sf.assignments || []).map((a) => ({
                        ...a,
                        visibilityType,
                      })),
                    },
              ),
            },
      ),
    );
    try {
      setLoader({ state: true, message: "Updating folder visibility..." });
      await BundleService.update_bundle(bundleId, {
        prefix: sfCode,
        visibilityType,
      });
      enqueueSnackbar("Folder visibility updated", { variant: "success" });
      fetchAllBundles();
    } catch (err) {
      setTrialBundles(prevBundles);
      enqueueSnackbar(err?.message || "Failed to update folder visibility", {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  };

  */


  const handleOpenDoc = (doc) => openViewer(doc);
  const handleBack = () => closeViewer();
  const handleTabClick = (doc) => {
    setActiveDoc(doc);
    setViewerPhase("visible");
    addRecentlyViewed(doc);
  };
  const handleTabClose = (doc) => {
    const rem = openTabs.filter((t) => t.id !== doc.id);
    setOpenTabs(rem);
    if (activeDoc?.id === doc.id) {
      if (rem.length > 0) {
        setActiveDoc(rem[rem.length - 1]);
        setViewerPhase("visible");
      } else closeViewer();
    }
  };

  const handleSectionSwitch = (section) => {

    setActiveSection(section);
    setSidebarOpen(false);
    if (section === "core") setCoreExpanded(true);
    else if (section === "trial") {
      setTrialExpanded(true);
      if (onNavigate) onNavigate("trailBundle");
    } else if (section === "private") {
      setPrivateExpanded(true);
      if (onNavigate) onNavigate("privateBundle");
    } else if (section === "transcripts") {
      if (onNavigate) onNavigate("transcripts");
    }
  };

  const pdfLoadingTasksRef = useRef([]);

  const fetchPageCount = async (url) => {
    if (!url) return null;
    let loadingTask = null;
    try {
      loadingTask = PDFJS.getDocument({ url });
      pdfLoadingTasksRef.current.push(loadingTask);
      const pdf = await loadingTask.promise;
      return pdf.numPages;
    } catch {
      return null;
    } finally {
      if (loadingTask) {
        pdfLoadingTasksRef.current = pdfLoadingTasksRef.current.filter(
          (t) => t !== loadingTask,
        );
      }
    }
  };

  useEffect(() => {
    return () => {
      pdfLoadingTasksRef.current.forEach((task) => {
        try { task.destroy(); } catch {}
      });
      pdfLoadingTasksRef.current = [];
    };
  }, []);

  const fetchDocuments = async (page = 1, perPage = 10, source = "All") => {
    setLoading(true);
    setError(null);
    let query = `?page=${page}&perPage=${perPage}`;
    if (source === "Claimant") query += "&claimantView=true";
    else if (source === "Respondent") query += "&respondentView=true";
    else if (source === "Neutral") query += "&commonView=true";
    try {
      const res = await CaseService.getcaseDocuments(id, query);
      if (!res?.data || !Array.isArray(res.data)) {
        setDocuments([]);
        setTotalDocs(0);
        return;
      }
      const transformed = res.data.map((doc) => ({
        ...doc,
        source: determineSource(doc),
        formattedDate: doc.created_at
          ? moment(doc.created_at).format("DD MMM YYYY")
          : "—",
        time: doc.created_at ? moment(doc.created_at).format("hh:mm A") : "",
        pageCount: null,
        fileUrl: doc.url?.url || null,
        ext: doc.url?.url?.split(".").pop()?.toLowerCase() || "pdf",
      }));
      setDocuments(transformed);
      setTotalDocs(res.total || 0);
      setLastPage(res.lastPage || 1);

      const needsProbe = transformed.filter(
        (d) => d.ext === "pdf" && d.fileUrl && d.pageCount === null,
      );
      if (!needsProbe.length) return;
      const CONCURRENCY = 5;
      const queue = [...needsProbe];
      const runBatch = async () => {
        while (queue.length > 0) {
          const batch = queue.splice(0, CONCURRENCY);
          const results = await Promise.all(
            batch.map(async (d) => ({
              id: d.id,
              pageCount: await fetchPageCount(d.fileUrl),
            })),
          );
          setDocuments((prev) =>
            prev.map((d) => {
              const r = results.find((r) => r.id === d.id);
              return r?.pageCount != null
                ? { ...d, pageCount: r.pageCount }
                : d;
            }),
          );
        }
      };
      runBatch().catch(() => {});
    } catch (err) {
      setError("Failed to load documents");
      setDocuments([]);
      setTotalDocs(0);
    } finally {
      setLoading(false);
    }
  };

  const determineSource = (doc) => {
    if (doc.ownerType === "claimant" || doc.claimantView) return "Claimant";
    if (doc.ownerType === "respondent" || doc.respondentView)
      return "Respondent";
    return "Neutral";
  };

  useEffect(() => {
    if (activeSection) fetchDocuments(currentPage, itemsPerPage, activeSource);
  }, [currentPage, itemsPerPage, activeSource, id, activeSection]); // eslint-disable-line

  const handleSourceChange = (source) => {
    setActiveSource(source);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => {
    if (page >= 1 && page <= lastPage) setCurrentPage(page);
  };
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };



  const toggleRow = (key) => setSelectedRows((p) => ({ ...p, [key]: !p[key] }));


  const getBundleSubFolders = (bundle) => bundle.bundles || [];
  const getVisibleSubFolderCount = (bundle) =>
    getBundleSubFolders(bundle).filter((sf) => !sf.isMainFolder).length;
  const getTabRef = (bundle, tabNum) =>
    `${bundle.bundleCode || bundle.id}/${tabNum}`;

  const parsePageCount = (pages) => {
    if (pages == null) return 0;
    const str = String(pages).trim();
    if (!str) return 0;
    return str.split(",").reduce((total, part) => {
      const segment = part.trim();
      if (!segment) return total;
      const rangeMatch = segment.match(/^(\d+)\s*[-–—]\s*(\d+)$/);
      if (rangeMatch) {
        const start = Number(rangeMatch[1]);
        const end = Number(rangeMatch[2]);
        if (!Number.isNaN(start) && !Number.isNaN(end) && end >= start)
          return total + (end - start + 1);
        return total;
      }
      const num = Number(segment);
      return Number.isNaN(num) ? total : total + 1;
    }, 0);
  };

  const getSubFolderTabGroups = (subFolder) => {
    const tabGroups = {};
    (subFolder.assignments || []).forEach((a) => {
      const k = `tab_${a.tabNum}`;
      const docName = a.userLabel ? a.userLabel.trim() : "";
      const pageCount = parsePageCount(a.pages);
      if (!tabGroups[k])
        tabGroups[k] = { tabNum: a.tabNum, docName, rows: [], totalPages: 0 };
      tabGroups[k].rows.push({ ...a, docName, pageCount, subFolder });
      tabGroups[k].totalPages += pageCount;
    });
    return Object.values(tabGroups).sort(
      (a, b) => Number(a.tabNum) - Number(b.tabNum),
    );
  };

  const privateBundles = useMemo(
    () => trialBundles.filter(isPrivateBundle),
    [trialBundles],
  );

  const activeBundleList =
    activeSection === "private" ? privateBundles : trialBundles;

  const filteredTrialBundles = useMemo(() => {
    const q = bundleSearch.trim().toLowerCase();
    if (!q) return activeBundleList;
    return activeBundleList.filter((b) => {
      if (
        (b.name || "").toLowerCase().includes(q) ||
        (b.bundleCode || String(b.id) || "").toLowerCase().includes(q)
      )
        return true;
      return (b.bundles || []).some((sf) => {
        if (
          (sf.name || "").toLowerCase().includes(q) ||
          (sf.code || "").toLowerCase().includes(q)
        )
          return true;
        return (sf.assignments || []).some((a) =>
          (a.userLabel || "").toLowerCase().includes(q),
        );
      });
    });
  }, [activeBundleList, bundleSearch]);

  const toggleBundleTree = (bundleId) =>
    setBundleTreeExpanded((p) => ({ ...p, [bundleId]: !p[bundleId] }));
  const toggleSubFolderTree = (bundleId, subCode) => {
    const key = `${bundleId}_${subCode}`;
    setSubFolderExpanded((p) => ({ ...p, [key]: !p[key] }));
  };

  const handleNavSelectBundle = (bundleId, section = "trial") => {
    setActiveSection(section);
    setActiveBundleId(bundleId);
    setActiveSubFolder(null);
    setActiveTabNum(null);
    setBundleTreeExpanded((p) => ({ ...p, [bundleId]: true }));
    setSidebarOpen(false);
    if (onNavigate)
      onNavigate(section === "private" ? "privateBundle" : "trailBundle");

    const bundle = trialBundles.find((b) => b.id === bundleId);
    if (bundle?.bundleCode) fetchBundleByCode(bundle.bundleCode);
  };
  const handleNavSelectSubFolder = (bundleId, subCode) => {
    setActiveSection("trial");
    setActiveBundleId(bundleId);
    setActiveSubFolder(subCode);
    setActiveTabNum(null);
    setBundleTreeExpanded((p) => ({ ...p, [bundleId]: true }));
    setSubFolderExpanded((p) => ({ ...p, [`${bundleId}_${subCode}`]: true }));
    setSidebarOpen(false);
    if (onNavigate) onNavigate("trailBundle");

    const bundle = trialBundles.find((b) => b.id === bundleId);
    if (bundle?.bundleCode) fetchBundleByCode(bundle.bundleCode);
  };
  const handleNavSelectTab = (bundleId, subCode, tabNum) => {
    setActiveSection("trial");
    setActiveBundleId(bundleId);
    setActiveSubFolder(subCode);
    setActiveTabNum(tabNum);
    setSidebarOpen(false);
    if (onNavigate) onNavigate("trailBundle");
  };

  const handleOpenBundleInTable = (bundle) => {
    setActiveBundleId(bundle.id);
    if (bundle?.bundleCode) fetchBundleByCode(bundle.bundleCode);
  };


  // const handleDownloadBundleZip = async (bundle) => {
  //   const subFolders = getBundleSubFolders(bundle);

  //   const allDocs = subFolders.flatMap((sf) =>
  //     (sf.assignments || []).map((a) => ({
  //       ...a,
  //       sfName: sf.isMainFolder ? "" : sf.name,
  //     })),
  //   );

  //   if (allDocs.length === 0) {
  //     enqueueSnackbar("This bundle has no documents to download.", {
  //       variant: "warning",
  //     });
  //     return;
  //   }

  //   try {
  //     setLoader({ state: true, message: "Preparing zip..." });
  //     const zip = new JSZip();
  //     const usedNames = new Set();

  //     await Promise.all(
  //       allDocs.map(async (doc) => {
  //         const url = doc.bundleDocumentUrl || doc.fileUrl;
  //         if (!url) return;

  //         try {
  //           const res = await fetch(url);
  //           if (!res.ok) return;
  //           const blob = await res.blob();

  //           const ext = url.split(".").pop()?.split("?")[0] || "pdf";
  //           let baseName = sanitizeFileName(
  //             doc.userLabel || `Tab_${doc.tabNum}`,
  //           );

  //           const folderPath = doc.sfName
  //             ? `${sanitizeFileName(doc.sfName)}/`
  //             : "";
  //           let fileName = `${folderPath}${baseName}.${ext}`;

  //           let counter = 1;
  //           while (usedNames.has(fileName)) {
  //             fileName = `${folderPath}${baseName}_${counter}.${ext}`;
  //             counter += 1;
  //           }
  //           usedNames.add(fileName);

  //           zip.file(fileName, blob);
  //         } catch (e) {}
  //       }),
  //     );

  //     const zipBlob = await zip.generateAsync({ type: "blob" });
  //     const zipUrl = URL.createObjectURL(zipBlob);
  //     const a = document.createElement("a");
  //     a.href = zipUrl;
  //     a.download = `${sanitizeFileName(bundle.name)}.zip`;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     URL.revokeObjectURL(zipUrl);

  //     enqueueSnackbar("Bundle downloaded", { variant: "success" });
  //   } catch (err) {
  //     enqueueSnackbar(err?.message || "Failed to download bundle", {
  //       variant: "error",
  //     });
  //   } finally {
  //     setLoader({ state: false });
  //   }
  // };

  const sectionMeta = {
    core: {
      icon: <CoreBundle size={17} color={G.teal} />,
      title: "Core Bundle",
      placeholder: "Search documents…",
    },
    trial: {
      icon: <IcoLayers size={17} color={G.teal} />,
      title: "Trial Bundles",
      placeholder: "Search bundles…",
    },
    private: {
      icon: <IcoLock size={17} color={G.teal} />,
      title: "My Private Bundles",
      placeholder: "Search private bundles…",
    },
  };
  const meta = sectionMeta[activeSection] || sectionMeta.core;

  const getTrialViewTitle = () => {
    if (!activeBundleId)
      return activeSection === "private"
        ? "My Private Bundles"
        : "Trial Bundles";
    const b = trialBundles.find((b) => b.id === activeBundleId);
    if (!b)
      return activeSection === "private"
        ? "My Private Bundles"
        : "Trial Bundles";
    /*
    if (activeSubFolder) {
      const sf = (b.bundles || []).find((s) => s.code === activeSubFolder);
      const sfName = sf ? `${sf.code} — ${sf.name}` : activeSubFolder;
      if (activeTabNum != null)
        return `${b.bundleCode || b.id} › ${sfName} › Tab ${activeTabNum}`;
      return `${b.bundleCode || b.id} — ${b.name} › ${sfName}`;
    }
    return `${b.bundleCode || b.id} — ${b.name}`;
    */

    // if (activeSubFolder) {
    //   const sf = (b.bundles || []).find((s) => s.code === activeSubFolder);
    //   const sfName = sf ? `${sf.name}` : activeSubFolder;
    //   if (activeTabNum != null) return `${sfName} › Tab ${activeTabNum}`;
    //   return `${b.name} › ${sfName}`;
    // }
    return activeSection === "private" ? "My Private Bundles" : "Trial Bundles";
  };

  const viewerMounted = viewerPhase !== "idle";
  const isDocOpen = viewerMounted && !!activeDoc;

  const renderSidebar = () => {
    if (sidebarCollapsed) {
      return (
        <CollapsedSidebarBar>
          <Tooltip title="Expand Sidebar" placement="right">
            <SidebarToggleBtn
              onClick={() => setSidebarCollapsed(false)}
              aria-label="Expand Sidebar"
            >
              <SidebarExpandIcon size={15} />
            </SidebarToggleBtn>
          </Tooltip>
        </CollapsedSidebarBar>
      );
    }

    return (
      <>
        <SidebarHeader>
          <SidebarTitle>Documents &amp; Bundles</SidebarTitle>
          <Tooltip title="Collapse Sidebar" placement="bottom">
            <SidebarToggleBtn
              onClick={() => setSidebarCollapsed(true)}
              aria-label="Collapse Sidebar"
            >
              <SidebarCollapseIcon size={15} />
            </SidebarToggleBtn>
          </Tooltip>
        </SidebarHeader>
        <NavSection>
          <NavRow
            $active={activeSection === "core" && activeSource === "All"}
            onClick={() => {
              setCoreExpanded((v) => !v);
              if (!isDocOpen) {
                setActiveSection("core");
                setActiveSource("All");
                setSidebarOpen(false);
              }
            }}
          >
            <ChevronWrap>
              {coreExpanded ? <IcoChevronDown /> : <IcoChevronRight />}
            </ChevronWrap>
            <NavIconWrap>
              <CoreBundle
                size={14}
                color={activeSection === "core" ? G.teal : G.slate500}
              />
            </NavIconWrap>
            <NavLabel $active={activeSection === "core"}>Core Bundle</NavLabel>
            <NavBadge $active={activeSection === "core"}>{totalDocs}</NavBadge>
            {/* <NavAddBtn onClick={(e) => e.stopPropagation()}>
            <IcoPlus size={10} color={G.teal} />
          </NavAddBtn> */}
          </NavRow>

          {coreExpanded && (
            <SubNav $flat>
              <BundleNavRow
                $active={activeSection === "core" && activeSource === "All"}
                style={{
                  borderLeft: `3px solid ${activeSection === "core" && activeSource === "All"
                    ? G.teal
                    : G.slate200
                    }`,
                  marginLeft: 8,
                  borderRadius: 0,
                  background:
                    activeSection === "core" && activeSource === "All"
                      ? G.tealLight
                      : "transparent",
                }}
              >
                <BundleNavContent
                  onClick={() => {
                    if (!isDocOpen) {
                      setActiveSection("core");
                      handleSourceChange("All");
                      setSidebarOpen(false);
                    }
                  }}
                >
                  <IcoFile
                    size={12}
                    color={
                      activeSection === "core" && activeSource === "All"
                        ? G.teal
                        : G.slate400
                    }
                  />
                  <BundleNavName
                    $active={activeSection === "core" && activeSource === "All"}
                  >
                    All Documents
                  </BundleNavName>
                </BundleNavContent>
                <NavBadge
                  $active={activeSection === "core" && activeSource === "All"}
                >
                  {totalDocs}
                </NavBadge>
              </BundleNavRow>

              {["Claimant", "Respondent", "Neutral"].map((src) => {
                const isActive = activeSection === "core" && activeSource === src;
                const dotColors = {
                  Claimant: G.amber,
                  Respondent: G.indigo,
                  Neutral: G.emerald,
                };
                return (
                  <BundleNavRow
                    key={src}
                    $active={isActive}
                    style={{
                      borderLeft: `3px solid ${isActive ? dotColors[src] : G.slate200}`,
                      marginLeft: 8,
                      borderRadius: 0,
                      paddingLeft: 20,
                      background: isActive
                        ? `${dotColors[src]}12`
                        : "transparent",
                    }}
                  >
                    <BundleNavContent
                      onClick={() => {
                        if (!isDocOpen) {
                          setActiveSection("core");
                          handleSourceChange(src);
                          setSidebarOpen(false);
                        }
                      }}
                    >
                      <SideVisibilityDot
                        style={{
                          background: dotColors[src],
                          minWidth: 7,
                          minHeight: 7,
                        }}
                      />
                      <BundleNavName $active={isActive}>
                        {src} Documents
                      </BundleNavName>
                    </BundleNavContent>
                    {isActive && <NavBadge $active>{totalDocs}</NavBadge>}
                  </BundleNavRow>
                );
              })}
            </SubNav>
          )}
        </NavSection>

        <NavSection>
          <NavRow
            $active={activeSection === "trial" && !activeBundleId}
            onClick={() => {
              setTrialExpanded((v) => !v);
              if (!isDocOpen) {
                setActiveSection("trial");
                setActiveBundleId(null);
                setActiveSubFolder(null);
                setActiveTabNum(null);
                setSidebarOpen(false);
                if (onNavigate) {
                  onNavigate("trailBundle");
                }
              }
            }}
          >
            <ChevronWrap>
              {trialExpanded ? <IcoChevronDown /> : <IcoChevronRight />}
            </ChevronWrap>
            <NavIconWrap>
              <IcoLayers
                size={14}
                color={activeSection === "trial" ? G.teal : G.slate500}
              />
            </NavIconWrap>
            <NavLabel $active={activeSection === "trial" && !activeBundleId}>
              Trial Bundles
            </NavLabel>
            <NavBadge $active={activeSection === "trial" && !activeBundleId}>
              {trialBundles.length}
            </NavBadge>

          </NavRow>

          {trialExpanded && (
            <SubNav $flat>
              {trialBundlesLoading && <SubNavEmpty>Loading bundles…</SubNavEmpty>}
              {!trialBundlesLoading && trialBundlesError && (
                <SubNavEmpty style={{ color: G.red }}>
                  {trialBundlesError}
                </SubNavEmpty>
              )}
              {!trialBundlesLoading &&
                !trialBundlesError &&
                trialBundles.length === 0 && (
                  <SubNavEmpty>No bundles yet</SubNavEmpty>
                )}
              {trialBundles.map((bundle) => {
                const isBundleActive =
                  activeSection === "trial" && activeBundleId === bundle.id;
                const isBundleOpen = !!bundleTreeExpanded[bundle.id];
                const subFolders = getBundleSubFolders(bundle);
                const visibleSubFolderCount = getVisibleSubFolderCount(bundle);

                return (
                  <div key={bundle.id}>
                    <BundleNavRow
                      $active={isBundleActive && !activeSubFolder}
                    >
                      <BundleNavChevron
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleBundleTree(bundle.id);
                        }}
                      >
                        {isBundleOpen ? (
                          <IcoChevronDown size={10} color={G.slate400} />
                        ) : (
                          <IcoChevronRight size={10} color={G.slate400} />
                        )}
                      </BundleNavChevron>


                      <BundleNavContent
                        onClick={() => {
                          if (isDocOpen) {
                            toggleBundleTree(bundle.id);
                          } else {
                            handleNavSelectBundle(bundle.id);
                          }
                        }}
                      >
                        <Layers
                          size={12}
                          color={
                            isBundleActive && !activeSubFolder
                              ? G.teal
                              : G.slate400
                          }
                        />
                        {/* <BundleNavIdChip
                          $active={isBundleActive && !activeSubFolder}
                        >
                          {bundle.bundleCode || bundle.id}
                        </BundleNavIdChip> */}

                        <BundleNavName
                          $active={isBundleActive && !activeSubFolder}
                        >
                          {bundle.name}
                        </BundleNavName>
                      </BundleNavContent>
                      <SideVisibilityDot
                        $visibility={bundle.visibilityType || "me"}
                        title={getVisibilityLabel(bundle.visibilityType)}
                      />
                      <NavBadge>
                        {visibleSubFolderCount > 0
                          ? visibleSubFolderCount
                          : subFolders.reduce(
                            (sum, sf) => sum + getSubFolderTabGroups(sf).length,
                            0,
                          )}
                      </NavBadge>
                    </BundleNavRow>

                    {isBundleOpen && (
                      <SubFolderNavList>
                        {subFolders.map((sf) => {
                          const sfKey = `${bundle.id}_${sf.code}`;
                          const isSFActive =
                            isBundleActive && activeSubFolder === sf.code;
                          const isSFOpen = !!subFolderExpanded[sfKey];
                          const tabGroups = getSubFolderTabGroups(sf);


                          if (sf.isMainFolder) {
                            return (
                              <React.Fragment key={sf.code}>
                                {tabGroups.map((tg) => {
                                  const isTabActive =
                                    isBundleActive && activeTabNum === tg.tabNum;
                                  return (
                                    <TabNavRow
                                      key={tg.tabNum}
                                      $active={isTabActive}
                                      onClick={() => {
                                        const firstRow = tg.rows[0] || {};
                                        if (isDocOpen) {
                                          openViewer({
                                            id: bundle.id,
                                            name:
                                              tg.docName ||
                                              firstRow.userLabel ||
                                              "Untitled Document",
                                            type: "pdf",
                                            s3url:
                                              firstRow?.bundleDocumentUrl ||
                                              firstRow?.fileUrl,
                                            visibilityType:
                                              firstRow?.visibilityType,
                                            bundle: true,
                                            sourceDocId:
                                              firstRow.sourceDocId,
                                            bundlecode: sf.code,
                                          });
                                        } else {
                                          handleNavSelectTab(
                                            bundle.id,
                                            sf.code,
                                            tg.tabNum,
                                          );
                                        }
                                      }}
                                      title={getTabRef(bundle, tg.tabNum)}
                                      style={{
                                        paddingLeft: 28,
                                        borderLeft: `3px solid ${isTabActive ? G.teal : G.slate200}`,
                                        marginLeft: 8,
                                        borderRadius: 0,
                                      }}
                                    >
                                      <IcoFile
                                        size={10}
                                        color={isTabActive ? G.teal : G.slate400}
                                      />
                                      <TabNavLabel $active={isTabActive}>
                                        {tg.docName || `Tab ${tg.tabNum}`}
                                      </TabNavLabel>
                                      <TabNavCount $active={isTabActive}>
                                        {tg.totalPages}p
                                      </TabNavCount>
                                    </TabNavRow>
                                  );
                                })}
                              </React.Fragment>
                            );
                          }

                          return (
                            <div key={sf.code}>
                              <SubFolderNavRow
                                $active={isSFActive && activeTabNum == null}

                                style={{
                                  borderLeft: `3px solid ${isSFActive && activeTabNum == null
                                    ? G.teal
                                    : G.tealMid
                                    }`,
                                  marginLeft: 8,
                                  borderRadius: 0,
                                  background:
                                    isSFActive && activeTabNum == null
                                      ? G.tealLight
                                      : "transparent",
                                }}
                              >
                                <SubFolderChevron
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleSubFolderTree(bundle.id, sf.code);
                                  }}
                                >
                                  {isSFOpen ? (
                                    <IcoChevronDown size={9} color={G.teal} />
                                  ) : (
                                    <IcoChevronRight
                                      size={9}
                                      color={G.slate400}
                                    />
                                  )}
                                </SubFolderChevron>


                                <SubFolderNavContent
                                  onClick={() => {
                                    if (isDocOpen) {
                                      toggleSubFolderTree(bundle.id, sf.code);
                                    } else {
                                      handleNavSelectSubFolder(
                                        bundle.id,
                                        sf.code,
                                      );
                                    }
                                  }}
                                >
                                  <IcoFolder
                                    size={11}
                                    color={
                                      isSFActive && activeTabNum == null
                                        ? G.teal
                                        : G.tealDark
                                    }
                                  />
                                  <SubFolderPrefixChip
                                    $active={isSFActive && activeTabNum == null}
                                  >
                                    {sf.code}
                                  </SubFolderPrefixChip>
                                  <SubFolderName
                                    $active={isSFActive && activeTabNum == null}
                                  >
                                    {sf.name}
                                  </SubFolderName>
                                </SubFolderNavContent>

                                <NavBadge
                                  $active={isSFActive && activeTabNum == null}
                                >
                                  {tabGroups.length}
                                </NavBadge>
                              </SubFolderNavRow>

                              {isSFOpen && (
                                <TabNavList>
                                  {tabGroups.length === 0 && (
                                    <TabNavEmpty>No tabs</TabNavEmpty>
                                  )}
                                  {tabGroups.map((tg) => {
                                    const isTabActive =
                                      isSFActive && activeTabNum === tg.tabNum;
                                    return (
                                      <TabNavRow
                                        key={tg.tabNum}
                                        $active={isTabActive}
                                        onClick={() => {
                                          const firstRow = tg.rows[0] || {};
                                          if (isDocOpen) {
                                            openViewer({
                                              id: bundle.id,
                                              name:
                                                tg.docName ||
                                                firstRow.userLabel ||
                                                "Untitled Document",
                                              type: "pdf",
                                              s3url:
                                                firstRow?.bundleDocumentUrl ||
                                                firstRow?.fileUrl,
                                              visibilityType:
                                                firstRow?.visibilityType,
                                              bundle: true,
                                              sourceDocId:
                                                firstRow.sourceDocId,
                                              bundlecode: sf.code,
                                            });
                                          } else {
                                            handleNavSelectTab(
                                              bundle.id,
                                              sf.code,
                                              tg.tabNum,
                                            );
                                          }
                                        }}

                                        style={{
                                          paddingLeft: 36,
                                          borderLeft: `3px solid ${isTabActive ? G.teal : G.tealMid}`,
                                          marginLeft: 8,
                                          borderRadius: 0,
                                        }}
                                      >
                                        <IcoFile
                                          size={10}
                                          color={
                                            isTabActive ? G.teal : G.slate400
                                          }
                                        />
                                        <TabNavLabel $active={isTabActive}>
                                          {tg.docName || `Tab ${tg.tabNum}`}
                                        </TabNavLabel>
                                        <TabNavCount $active={isTabActive}>
                                          {tg.totalPages}p
                                        </TabNavCount>
                                      </TabNavRow>
                                    );
                                  })}
                                </TabNavList>
                              )}
                            </div>
                          );
                        })}


                      </SubFolderNavList>
                    )}
                  </div>
                );
              })}
            </SubNav>
          )}
        </NavSection>
        <NavSection>
          <NavRow
            $active={activeSection === "private"}
            onClick={() => {
              setPrivateExpanded((v) => !v);
              if (!isDocOpen) {
                handleSectionSwitch("private");
              }
            }}
          >
            <ChevronWrap>
              {privateExpanded ? <IcoChevronDown /> : <IcoChevronRight />}
            </ChevronWrap>
            <NavIconWrap>
              <IcoLock
                size={14}
                color={activeSection === "private" ? G.teal : G.slate500}
              />
            </NavIconWrap>
            <NavLabel $active={activeSection === "private"}>
              My Private Bundles
            </NavLabel>
            <NavBadge $active={activeSection === "private"}>
              {privateBundles.length}
            </NavBadge>
          </NavRow>
          {privateExpanded && (
            <SubNav $flat>
              {privateBundles.length === 0 && (
                <SubNavEmpty>No private bundles yet</SubNavEmpty>
              )}
              {privateBundles.map((bundle) => {
                const isBundleActive =
                  activeSection === "private" && activeBundleId === bundle.id;
                return (
                  <BundleNavRow key={bundle.id} $active={isBundleActive}>
                    <BundleNavContent
                      onClick={() => {
                        if (isDocOpen) {
                          toggleBundleTree(bundle.id);
                        } else {
                          handleNavSelectBundle(bundle.id, "private");
                        }
                      }}
                    >
                      <IcoLock
                        size={12}
                        color={isBundleActive ? G.teal : G.slate400}
                      />
                      <BundleNavIdChip $active={isBundleActive}>
                        {bundle.bundleCode || bundle.id}
                      </BundleNavIdChip>
                      <BundleNavName $active={isBundleActive}>
                        {bundle.name}
                      </BundleNavName>
                    </BundleNavContent>
                    <NavBadge $active={isBundleActive}>
                      {(bundle.bundles || []).length}
                    </NavBadge>
                  </BundleNavRow>
                );
              })}
            </SubNav>
          )}
        </NavSection>
        <NavSection>
          <NavRow
            $active={false}
            onClick={() => setRecentlyViewedExpanded((v) => !v)}
          >
            <ChevronWrap>
              {recentlyViewedExpanded ? (
                <IcoChevronDown />
              ) : (
                <IcoChevronRight />
              )}
            </ChevronWrap>
            <NavIconWrap>
              <IcoClock size={14} color={G.slate500} />
            </NavIconWrap>
            <NavLabel>Recently Viewed Documents</NavLabel>
            <NavBadge>{recentlyViewed.length}</NavBadge>
          </NavRow>
          {recentlyViewedExpanded && (
            <SubNav $flat>
              {recentlyViewed.length === 0 ? (
                <SubNavEmpty>No recently viewed documents.</SubNavEmpty>
              ) : (
                recentlyViewed.map((doc, idx) => {
                  const isDocActive =
                    activeDoc && isSameDocument(activeDoc, doc);
                  return (
                    <BundleNavRow
                      key={doc.s3url || `${doc.id}_${idx}`}
                      $active={isDocActive}
                    >
                      <BundleNavContent
                        onClick={() => {
                          openViewer(doc);
                        }}
                      >
                        <IcoFile
                          size={12}
                          color={isDocActive ? G.teal : G.slate400}
                        />
                        <BundleNavName $active={isDocActive} title={doc.name}>
                          {doc.name}
                        </BundleNavName>
                      </BundleNavContent>
                    </BundleNavRow>
                  );
                })
              )}
            </SubNav>
          )}
        </NavSection>
        <SidebarSummary>
          <SidebarSummaryItem>
            <strong style={{ color: COLORS.COLOR_DARK }}>
              {trialBundles.length}
            </strong>
            <span>Trial bundles</span>
          </SidebarSummaryItem>
          <SidebarSummaryItem>
            <strong style={{ color: COLORS.COLOR_DARK }}>
              {privateBundles.length}
            </strong>
            <span>Private bundles</span>
          </SidebarSummaryItem>
        </SidebarSummary>
      </>
    );
  };

  const renderTrialBundlesTable = () => {
    const emptyTitle =
      activeSection === "private"
        ? "No private bundles yet"
        : "No trial bundles yet";
    const emptyHint =
      activeSection === "private"
        ? "Change any bundle visibility to Private to show it here."
        : "Create your first trial bundle to organise documents for the hearing.";

    if (trialBundlesLoading && activeBundleList.length === 0) {
      return (
        <EmptyState>
          <Spinner $size="28px" />
          <EmptyText style={{ marginTop: 14 }}>Loading bundles…</EmptyText>
        </EmptyState>
      );
    }

    if (trialBundlesError && activeBundleList.length === 0) {
      return (
        <EmptyState>
          <EmptyText style={{ color: G.red }}>{trialBundlesError}</EmptyText>
          <PrimaryBtn style={{ marginTop: 16 }} onClick={fetchAllBundles}>
            Retry
          </PrimaryBtn>
        </EmptyState>
      );
    }

    if (activeBundleList.length === 0) {
      return (
        <EmptyState>
          <EmptyIconBox
            style={{ background: G.tealLight, borderColor: G.tealMid }}
          >
            <IcoLayers size={28} color={G.teal} />
          </EmptyIconBox>
          <EmptyText>{emptyTitle}</EmptyText>
          <EmptyHint>{emptyHint}</EmptyHint>

        </EmptyState>
      );
    }

    const bundlesToShow = activeBundleId
      ? filteredTrialBundles.filter((b) => b.id === activeBundleId)
      : filteredTrialBundles;

    return (
      <BundlesWrap>
        <BundleSearchBar>
          <IcoSearch size={14} color={G.slate400} />
          <input
            placeholder="Search bundles, sub-folders, prefixes, documents…"
            value={bundleSearch}
            onChange={(e) => setBundleSearch(e.target.value)}
          />
          {bundleSearch && (
            <ClearSearchBtn onClick={() => setBundleSearch("")}>
              <IcoX size={11} color={G.slate400} />
            </ClearSearchBtn>
          )}
        </BundleSearchBar>

        {bundleSearch && filteredTrialBundles.length === 0 && (
          <NoResultsBanner>
            No bundles match "<strong>{bundleSearch}</strong>"
          </NoResultsBanner>
        )}

        {bundlesToShow.map((bundle) => {
          const subFolders = getBundleSubFolders(bundle);
          const sfToShow = activeSubFolder
            ? subFolders.filter((sf) => sf.code === activeSubFolder)
            : subFolders;
          // const activeVisibleSubFolder =
          //   activeSubFolder && !sfToShow[0]?.isMainFolder;
          const visibleSubFolderCount = getVisibleSubFolderCount(bundle);

          const totalAssignments = subFolders.reduce(
            (sum, sf) =>
              sum +
              (sf.assignments || []).reduce(
                (pSum, a) => pSum + parsePageCount(a.pages),
                0,
              ),
            0,
          );
          const totalTabs = subFolders.reduce(
            (sum, sf) => sum + getSubFolderTabGroups(sf).length,
            0,
          );




          return (
            <BundleBlock key={bundle.id}>
              {/* Bundle header */}
              <BundleHeader
                onClick={() => {
                  if (activeBundleId !== bundle.id)
                    handleOpenBundleInTable(bundle);
                }}
              >
                <BundleHeaderLeft>
                  <BundleHeaderTop>

                    <BundleTitle>
                      <BundleIdChip>{bundle.name || bundle.id}</BundleIdChip>

                    </BundleTitle>

                  </BundleHeaderTop>

                  <BundleMeta>
                    <VisibilityBadge
                      $visibility={bundle.visibilityType || "me"}
                      style={{
                        background: "rgba(255,255,255,0.12)",
                        border: "1px solid rgba(255,255,255,0.2)",
                        color: "#fff",
                        fontSize: "10px",
                      }}
                    >
                      {getVisibilityLabel(bundle.visibilityType)}
                    </VisibilityBadge>
                  </BundleMeta>

                  <BundleStats>
                    <BundleStat>
                      <span>Sub Folders</span>
                      <strong>{visibleSubFolderCount}</strong>
                    </BundleStat>
                    <BundleStat>
                      <span>Tabs</span>
                      <strong>{totalTabs}</strong>
                    </BundleStat>
                    <BundleStat>
                      <span>Pages</span>
                      <strong>{totalAssignments}</strong>
                    </BundleStat>
                  </BundleStats>
                </BundleHeaderLeft>

              </BundleHeader>

              {sfToShow.length === 0 ? (
                <EmptyRowBlock>
                  <IcoFolder size={16} color={G.slate300} />
                  <span>No sub-folders in this bundle.</span>

                </EmptyRowBlock>
              ) : (
                sfToShow.map((sf) => {
                  const tabGroups = getSubFolderTabGroups(sf);
                  const tabsToShow =
                    activeSubFolder && activeTabNum != null
                      ? tabGroups.filter((tg) => tg.tabNum === activeTabNum)
                      : tabGroups;


                  return (
                    <SubFolderBlock key={sf.code}>
                      {!sf.isMainFolder && (
                        <SubFolderHeader>
                          <SfHeaderLeft>
                            <SfName>
                              <SfLabel>Sub-folder:</SfLabel>
                              <Highlight
                                text={sf.name}
                                query={bundleSearch}
                              />

                            </SfName>

                          </SfHeaderLeft>

                        </SubFolderHeader>
                      )}
                      <TableWrap>
                        <InnerTable>
                          <thead>
                            <InnerTr $head>

                              <ColTh style={{ width: 130, paddingLeft: 16 }}>
                                TAB / REF
                              </ColTh>
                              <ColTh>DESCRIPTION OF DOCUMENT</ColTh>

                            </InnerTr>
                          </thead>
                          <tbody>
                            {tabsToShow.length === 0 ? (
                              <tr>
                                <EmptyRowTd colSpan={8}>
                                  {activeTabNum != null
                                    ? `No pages assigned to Tab ${activeTabNum}.`
                                    : "No pages assigned to this sub-folder yet."}

                                </EmptyRowTd>
                              </tr>
                            ) : (
                              tabsToShow.map((tg) => {
                                const rowKey = `${bundle.id}:${sf.code}:${tg.tabNum}`;
                                const firstRow = tg.rows[0] || {};
                                const totalPagesInTab = tg.totalPages || 0;

                                return (
                                  <React.Fragment key={tg.tabNum}>
                                    <tr>
                                      <TabSeparatorTd colSpan={2}>
                                        <TabSepInner>
                                          <TabLabelGroup>
                                            <TabLabel></TabLabel>
                                            {/* <TabRefText>
                                              {bundle.bundleCode}/TAB/
                                              {tg.tabNum}
                                            </TabRefText> */}
                                          </TabLabelGroup>
                                          <TabSepMeta>
                                            {/* {totalPagesInTab} page
                                            {totalPagesInTab !== 1 ? "s" : ""} */}
                                          </TabSepMeta>
                                        </TabSepInner>
                                      </TabSeparatorTd>
                                    </tr>
                                    <DataRow $selected={!!selectedRows[rowKey]}>
                                      <td
                                        style={{ width: 130, paddingLeft: 16 }}
                                      >
                                        <RefChip>
                                          {bundle.bundleCode}/{tg.tabNum}
                                        </RefChip>
                                      </td>
                                      <td>
                                        <DocDescRow>
                                          <DocIconFrame>
                                            <IcoFile size={13} color={G.teal} />
                                          </DocIconFrame>
                                          <div>
                                            <DocDescText

                                              onClick={() =>
                                                handleOpenDoc({
                                                  id: bundle.id,
                                                  name:
                                                    tg.docName ||
                                                    firstRow.userLabel ||
                                                    "Untitled Document",
                                                  type: "pdf",
                                                  s3url:
                                                    firstRow?.bundleDocumentUrl ||
                                                    firstRow?.fileUrl,
                                                  visibilityType:
                                                    firstRow?.visibilityType,
                                                  bundle: true,
                                                  sourceDocId:
                                                    firstRow.sourceDocId,
                                                  bundlecode: sf.code,
                                                })
                                              }
                                            >
                                              <Highlight
                                                text={
                                                  tg.docName ||
                                                  firstRow.userLabel ||
                                                  "Untitled Document"
                                                }
                                                query={bundleSearch}
                                              />
                                            </DocDescText>
                                            <DocDescMeta>
                                              Bundle document

                                              <MetaDivider />
                                              {totalPagesInTab} page
                                              {totalPagesInTab > 1 ? "s" : ""}
                                            </DocDescMeta>
                                          </div>
                                        </DocDescRow>
                                      </td>

                                    </DataRow>
                                  </React.Fragment>
                                );
                              })
                            )}
                          </tbody>
                        </InnerTable>
                      </TableWrap>
                      <MobileSfCards>
                        {tabsToShow.length === 0 && (
                          <MobileEmpty>
                            No tabs assigned.

                          </MobileEmpty>
                        )}
                        {tabsToShow.map((tg) => {
                          const rowKey = `${bundle.id}:${sf.code}:${tg.tabNum}`;
                          const firstRow = tg.rows[0] || {};

                          return (
                            <MobileSfCard
                              key={tg.tabNum}
                              $selected={!!selectedRows[rowKey]}
                            >
                              <MobileSfCardTop>
                                <RefChip>
                                  {bundle.bundleCode}/{tg.tabNum}
                                </RefChip>
                                <TabLabel>TAB {tg.tabNum}</TabLabel>
                              </MobileSfCardTop>
                              <MobileSfCardName
                                onClick={() =>
                                  handleOpenDoc({
                                    id: bundle.id,
                                    name:
                                      tg.docName ||
                                      firstRow.userLabel ||
                                      "Untitled Document",
                                    type: "pdf",
                                    s3url:
                                      firstRow?.bundleDocumentUrl ||
                                      firstRow?.fileUrl,
                                    visibilityType: firstRow?.visibilityType,
                                    bundle: true,
                                    sourceDocId: firstRow.sourceDocId,
                                    bundlecode: sf.code,
                                  })
                                }
                              >
                                <IcoFile size={12} color={G.slate400} />
                                <span>
                                  <Highlight
                                    text={
                                      tg.docName ||
                                      firstRow.userLabel ||
                                      "Untitled Document"
                                    }
                                    query={bundleSearch}
                                  />
                                </span>
                              </MobileSfCardName>
                              <MobileSfCardMeta>
                                {firstRow.source && (
                                  <SourceBadge source={firstRow.source} />
                                )}
                                <DateText>
                                  {firstRow.date
                                    ? moment(firstRow.date).format(
                                      "DD MMM YYYY",
                                    )
                                    : "—"}
                                </DateText>

                              </MobileSfCardMeta>
                            </MobileSfCard>
                          );
                        })}
                      </MobileSfCards>
                    </SubFolderBlock>
                  );
                })
              )}
            </BundleBlock>
          );
        })}
      </BundlesWrap>
    );
  };
  return (
    <Shell>
      {sidebarOpen && <Overlay onClick={() => setSidebarOpen(false)} />}
      <Sidebar $open={sidebarOpen} $collapsed={sidebarCollapsed}>
        {renderSidebar()}
      </Sidebar>

      <Main>
        {activeDoc ? null : (
          <TopBar>
            <TopLeft>
              <HamburgerBtn onClick={() => setSidebarOpen((v) => !v)}>
                <IcoMenu size={18} color={G.slate700} />
              </HamburgerBtn>
              <BackBtn onClick={onBack} title="Back">
                <IcoChevronLeft size={13} color={G.teal} />
              </BackBtn>
              <PageIconBox>{meta.icon}</PageIconBox>
              <PageTitleGroup>
                <PageTitle>
                  {activeSection === "trial" ? getTrialViewTitle() : meta.title}
                </PageTitle>
                <PageSub>
                  {/* {activeSection === "core"
                    ? `${totalDocs} documents`
                    : activeSection === "trial" || activeSection === "private"
                      ? activeBundleId
                        ? activeSubFolder
                          ? activeTabNum != null
                            ? `Tab ${activeTabNum}`
                            : (() => {
                                const b = trialBundles.find(
                                  (b) => b.id === activeBundleId,
                                );
                                const sf = (b?.bundles || []).find(
                                  (s) => s.code === activeSubFolder,
                                );
                                const tabCount = getSubFolderTabGroups(
                                  sf || {},
                                ).length;
                                return `${tabCount} tab${tabCount !== 1 ? "s" : ""}`;
                              })()
                          : (() => {
                              const b = trialBundles.find(
                                (b) => b.id === activeBundleId,
                              );
                              const visibleSf = (b?.bundles || []).filter(
                                (sf) => !sf.isMainFolder,
                              );
                              if (visibleSf.length > 0) {
                                return `${visibleSf.length} sub-folder${visibleSf.length !== 1 ? "s" : ""}`;
                              }
                              const totalTabs = (b?.bundles || []).reduce(
                                (sum, sf) =>
                                  sum + getSubFolderTabGroups(sf).length,
                                0,
                              );
                              return `${totalTabs} tab${totalTabs !== 1 ? "s" : ""}`;
                            })()
                        : `${activeBundleList.length} bundle${activeBundleList.length !== 1 ? "s" : ""}`
                      : "0 bundles"} */}
                  {activeSection === "core" ? `${totalDocs} documents` : null}
                </PageSub>
              </PageTitleGroup>
            </TopLeft>

          </TopBar>
        )}

        <ViewportWrap>
          {activeSection === "core" && (
            <FilterStrip>
              <FilterLabel>Filter by source</FilterLabel>
              <FilterPills>
                {["All", "Claimant", "Respondent", "Neutral"].map((src) => (
                  <Pill
                    key={src}
                    $active={activeSource === src}
                    onClick={() => handleSourceChange(src)}
                  >
                    {src !== "All" && (
                      <SourceDot $source={src} style={{ marginRight: 5 }} />
                    )}
                    {src}
                  </Pill>
                ))}
              </FilterPills>
            </FilterStrip>
          )}

          <SectionBar>
            {/* <SectionTitle>
                {activeSection === "core"
                  ? `Core Bundle — ${activeSource === "All" ? "All Documents" : `${activeSource} Documents`}`
                  : activeSection === "trial" || activeSection === "private"
                    ? getTrialViewTitle()
                    : activeSection === "private"
                      ? "My Private Bundles"
                      : "Transcripts"}
              </SectionTitle>
              <SectionMeta>
                {activeSection === "core"
                  ? `${totalDocs} total`
                  : activeSection === "trial" || activeSection === "private"
                    ? `${activeBundleList.length} bundle${activeBundleList.length !== 1 ? "s" : ""}${bundleSearch ? ` · ${filteredTrialBundles.length} match` : ""}`
                    : "0 items"}
              </SectionMeta> */}
          </SectionBar>

          {activeSection === "core" && (
            <Content>
              {loading && (
                <EmptyState>
                  <Spinner $size="28px" />
                  <EmptyText style={{ marginTop: 14 }}>
                    Loading documents…
                  </EmptyText>
                </EmptyState>
              )}
              {error && (
                <EmptyState>
                  <EmptyText style={{ color: G.red }}>{error}</EmptyText>
                </EmptyState>
              )}
              {!loading && !error && documents.length === 0 && (
                <EmptyState>
                  <EmptyIconBox>
                    <IcoFile size={26} color={G.slate400} />
                  </EmptyIconBox>
                  <EmptyText>No documents found</EmptyText>
                  <EmptyHint>Upload a document to get started</EmptyHint>
                </EmptyState>
              )}

              {documents.length > 0 && (
                <BundlesWrap>
                  <BundleSearchBar>
                    <IcoSearch size={14} color={G.slate400} />
                    <input
                      placeholder="Search documents by name, reference…"
                      value={bundleSearch}
                      onChange={(e) => setBundleSearch(e.target.value)}
                    />
                    {bundleSearch && (
                      <ClearSearchBtn onClick={() => setBundleSearch("")}>
                        <IcoX size={11} color={G.slate400} />
                      </ClearSearchBtn>
                    )}
                  </BundleSearchBar>

                  <BundleBlock>
                    <BundleHeader>
                      <BundleHeaderLeft>
                        <BundleHeaderTop>
                          <BundleTitle>
                            <BundleIdChip>
                              {activeSource === "All"
                                ? "All Documents"
                                : `${activeSource} Documents`}
                            </BundleIdChip>
                          </BundleTitle>
                        </BundleHeaderTop>
                        <BundleStats>
                          <BundleStat>
                            <span>Total</span>
                            <strong>{totalDocs}</strong>
                          </BundleStat>
                          <BundleStat>
                            <span>Showing</span>
                            <strong>{documents.length}</strong>
                          </BundleStat>
                        </BundleStats>
                      </BundleHeaderLeft>

                    </BundleHeader>

                    <SubFolderBlock>
                      {/* <SubFolderHeader>
                        <SfHeaderLeft></SfHeaderLeft>
                        <SfHeaderRight>
                          <FilterPills style={{ margin: 0 }}>
                            {["All", "Claimant", "Respondent", "Neutral"].map(
                              (src) => (
                                <Pill
                                  key={src}
                                  $active={activeSource === src}
                                  onClick={() => handleSourceChange(src)}
                                  style={{ fontSize: 11 }}
                                >
                                  {src !== "All" && (
                                    <SourceDot
                                      $source={src}
                                      style={{ marginRight: 4 }}
                                    />
                                  )}
                                  {src}
                                </Pill>
                              ),
                            )}
                          </FilterPills>
                        </SfHeaderRight>
                      </SubFolderHeader> */}

                      <TableWrap>
                        <InnerTable>
                          <thead>
                            <InnerTr $head>

                              <ColTh style={{ width: 110, paddingLeft: 16 }}>
                                REF
                              </ColTh>
                              <ColTh>DOCUMENT NAME</ColTh>
                              <ColTh style={{ width: 110 }}>EXHIBIT ID</ColTh>
                              <ColTh style={{ width: 120 }}>DATE</ColTh>
                              <ColTh style={{ width: 70, textAlign: "center" }}>
                                PAGES
                              </ColTh>
                              <ColTh style={{ width: 120 }}>SUBMITTED BY</ColTh>
                              {!viewOnly && (
                                <ColTh style={{ width: 90 }}>TYPE</ColTh>
                              )}
                              <ColTh style={{ width: 60, textAlign: "center" }}>
                                VISIBILITY
                              </ColTh>

                            </InnerTr>
                          </thead>
                          <tbody>
                            {documents
                              .filter(
                                (doc) =>
                                  !bundleSearch.trim() ||
                                  (doc.name || "")
                                    .toLowerCase()
                                    .includes(
                                      bundleSearch.trim().toLowerCase(),
                                    ) ||
                                  String(doc.documentNo ?? "")
                                    .toLowerCase()
                                    .includes(
                                      bundleSearch.trim().toLowerCase(),
                                    ),
                              )
                              .map((doc) => {
                                const isCMEditable =
                                  doc?.ownerType === "caseManager";
                                const isPrivate =
                                  doc?.visibilityType === "me" ||
                                  doc?.visibilityType === "strictMode";
                                const isShared =
                                  doc?.visibilityType === "others";
                                const { Icon, title, clickable } = isPrivate
                                  ? {
                                    Icon: HttpsIcon,
                                    title: "Private",
                                    clickable: isCMEditable,
                                  }
                                  : isShared
                                    ? {
                                      Icon: HttpsLockOpen,
                                      title: isCMEditable
                                        ? "Shared with Neutral"
                                        : "Shared with CM and Neutral",
                                      clickable: isCMEditable,
                                    }
                                    : {
                                      Icon: PublicIcon,
                                      title: "Public",
                                      clickable: isCMEditable,
                                    };

                                return (
                                  <React.Fragment key={doc.id}>
                                    <tr>
                                      <TabSeparatorTd colSpan={viewOnly ? 7 : 8}>
                                        <TabSepInner>
                                          <TabLabelGroup>
                                            <TabLabel />
                                          </TabLabelGroup>
                                          <TabSepMeta />
                                        </TabSepInner>
                                      </TabSeparatorTd>
                                    </tr>
                                    <DataRow>
                                      <td
                                        style={{
                                          width: 110,
                                          paddingLeft: 16,
                                        }}
                                      >
                                        <RefChip
                                          onClick={() =>

                                            window.open(doc.url?.url, "_blank")
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          {doc.documentNo || "—"}
                                        </RefChip>
                                      </td>
                                      <td>
                                        <DocDescRow>
                                          <DocIconFrame>
                                            <IcoFile size={13} color={G.teal} />
                                          </DocIconFrame>
                                          <div>
                                            <DocDescText

                                              onClick={() =>
                                                handleOpenDoc({
                                                  id: doc.id,
                                                  name: doc.name,
                                                  type: doc?.url?.uploadType,
                                                  s3url: doc?.url?.url,
                                                  visibilityType:
                                                    doc?.visibilityType,
                                                  keywords: doc.keywords,
                                                  documentSummary:
                                                    doc.documentSummary,
                                                })
                                              }
                                            >
                                              <Highlight
                                                text={doc.name}
                                                query={bundleSearch}
                                              />
                                            </DocDescText>
                                            <DocDescMeta>
                                              {"Document"}

                                              {doc.pageCount != null && (
                                                <>
                                                  <MetaDivider />
                                                  {doc.pageCount} page
                                                  {doc.pageCount !== 1
                                                    ? "s"
                                                    : ""}
                                                </>
                                              )}
                                            </DocDescMeta>
                                          </div>
                                        </DocDescRow>
                                      </td>
                                      <td>
                                        {doc.exhibitId ||
                                          doc.exhibit_id ||
                                          doc.exhibitCode ||
                                          doc.exhibit_code ||
                                          doc.properties?.exhibitId ||
                                          doc.properties?.exhibit_id ||
                                          doc.properties?.exhibitNo ||
                                          doc.properties?.exhibit_no ||
                                          "—"}
                                      </td>
                                      <td>
                                        <DateLine>{doc.formattedDate}</DateLine>
                                        <TimeLine>{doc.time}</TimeLine>
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {doc.pageCount != null ? (
                                          <PageChip>{doc.pageCount}</PageChip>
                                        ) : (
                                          <DimText>…</DimText>
                                        )}
                                      </td>
                                      <td>
                                        <OwnerBadge>
                                          {doc.owner?.name || "—"}
                                        </OwnerBadge>
                                      </td>
                                      {!viewOnly && (
                                        <td>

                                          <DocNameRow>
                                            <DocName>
                                              {doc?.url?.uploadType ||
                                                "other"}
                                            </DocName>
                                          </DocNameRow>

                                        </td>
                                      )}
                                      <td style={{ textAlign: "center" }}>
                                        <Tooltip title={title} placement="top">
                                          <Icon
                                            style={{
                                              fontSize: 14,
                                              fill: COLORS.COLOR_DARK,
                                              cursor: clickable
                                                ? "pointer"
                                                : "default",
                                            }}

                                          />
                                        </Tooltip>
                                      </td>

                                    </DataRow>
                                  </React.Fragment>
                                );
                              })}
                          </tbody>
                        </InnerTable>
                      </TableWrap>
                      <MobileCardList>
                        {documents.map((doc) => (
                          <MobileDocCard
                            key={doc.id}

                            onClick={() =>
                              handleOpenDoc({
                                id: doc.id,
                                name: doc.name,
                                type: doc?.url?.uploadType,
                                s3url: doc?.url?.url,
                                visibilityType: doc?.visibilityType,
                              })
                            }
                          >

                            <MobileDocIconBox>
                              <IcoFile size={16} color={G.teal} />
                            </MobileDocIconBox>
                            <MobileDocBody>
                              <MobileDocName>{doc.name}</MobileDocName>
                              <MobileDocMeta>
                                <DocRef
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    window.open(doc.url?.url, "_blank");
                                  }}
                                >
                                  {doc.documentNo}
                                </DocRef>
                                <span style={{ color: G.slate300 }}>·</span>
                                <span>{doc.formattedDate}</span>
                                {doc.pageCount != null && (
                                  <>
                                    <span style={{ color: G.slate300 }}>·</span>
                                    <span>{doc.pageCount}p</span>
                                  </>
                                )}
                              </MobileDocMeta>
                            </MobileDocBody>

                          </MobileDocCard>
                        ))}
                      </MobileCardList>
                    </SubFolderBlock>
                  </BundleBlock>
                </BundlesWrap>
              )}
            </Content>
          )}

          {(activeSection === "trial" || activeSection === "private") && (
            <Content>{renderTrialBundlesTable()}</Content>
          )}

          {activeSection === "core" && totalDocs > 0 && (
            <PaginationBar>
              <PaginationInfo>
                Showing{" "}
                <strong>
                  {(currentPage - 1) * itemsPerPage + 1}–
                  {Math.min(currentPage * itemsPerPage, totalDocs)}
                </strong>{" "}
                of <strong>{totalDocs}</strong>
              </PaginationInfo>
              <PaginationRight>
                <PageControls>
                  <PageBtn
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    ← Prev
                  </PageBtn>
                  {Array.from(
                    { length: Math.min(lastPage, 7) },
                    (_, i) => i + 1,
                  ).map((p) => (
                    <PageBtn
                      key={p}
                      $active={p === currentPage}
                      onClick={() => handlePageChange(p)}
                    >
                      {p}
                    </PageBtn>
                  ))}
                  {lastPage > 7 && (
                    <span style={{ color: G.slate400, padding: "0 3px" }}>
                      …
                    </span>
                  )}
                  <PageBtn
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === lastPage}
                  >
                    Next →
                  </PageBtn>
                </PageControls>
                <PerPageSelect
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                >
                  <option value={10}>10 / page</option>
                  <option value={20}>20 / page</option>
                  <option value={50}>50 / page</option>
                </PerPageSelect>
              </PaginationRight>
            </PaginationBar>
          )}

          {viewerMounted && activeDoc && (
            <ViewerPane $phase={viewerPhase}>
              <DocumentViewer
                doc={activeDoc}
                onBack={handleBack}
                openTabs={openTabs}
                onTabClick={handleTabClick}
                onTabClose={handleTabClose}
                id={id}
                setTrigger={() =>
                  fetchDocuments(currentPage, itemsPerPage, activeSource)
                }
                fetchAllBundles={fetchAllBundles}

              />
            </ViewerPane>
          )}
        </ViewportWrap>
      </Main>
      <ViewKeywords view={viewKeywords} setView={setViewKeywords} />


    </Shell>
  );
};

export default CoreBundleView;
